import { useAppSelector } from "../../store/hooks";
import { isUrisBrand } from "../../utils/brandLogo";
import { isFzToken } from "../../utils/fzLab";
import CaseDetailsFormOld from "./caseDetailsFormOld";
import CaseDetailsFormNew from "./caseDetailsFormNew";
import UrisCaseUpload from "./UrisCaseUpload";

export const CaseDetailsForm = () => {
  const { user } = useAppSelector((state) => state.auth);
  if (isFzToken(user?.token)) {
    return (
      <div className="mx-auto max-w-xl rounded-xl border border-amber-200 bg-amber-50 p-6 text-amber-950">
        <h2 className="text-lg font-semibold mb-2">FZ case create disabled</h2>
        <p className="text-sm">
          FZ lab cases are created only from Local Downloader → FZ Sync using zip
          file names. Portal create and Box uploads are disabled for FZ.
        </p>
      </div>
    );
  }
  if (isUrisBrand(user)) {
    return <UrisCaseUpload />;
  }
  if (user?.role === "Super Admin" || user?.token === "TM") {
    return <CaseDetailsFormNew />;
  }
  return <CaseDetailsFormOld />;
};

export default CaseDetailsForm;
